import { yupResolver } from '@hookform/resolvers/yup';
import { Box, Grid, Typography } from '@mui/material';
import { t } from 'i18next';
import React, { useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import { VERIFY_EMAIL } from 'src/apiService/apiDeclaration';
import Wrapper from 'src/components/common/wrapper';
import CustomTextField from 'src/components/formFields/textField';
import LoaderButton from 'src/components/loaderButton/loaderButton';
import { forgetFormSchema } from 'src/config/yup';
import { OTP_VERIFICATION_MODE, showErrorTost, showSuccessTost } from 'src/constants';

const ForgotPassword = () => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const {
    handleSubmit,
    control,
    formState: { errors, isValid },
  } = useForm({
    mode: 'onChange',
    resolver: yupResolver(forgetFormSchema),
  });
  const forgetform = async (body) => {
    setLoading(true);
    try {
      await VERIFY_EMAIL(body);
      showSuccessTost('Account found OTP has been sent to your email');
      navigate('/otp', { state: { email: body.email, verifcationMode: OTP_VERIFICATION_MODE.ACCOUNT_RECOVERY } });
    } catch (error) {
      showErrorTost(error.message);
    } finally {
      setLoading(false);
    }
  };
  return (
    <Wrapper>
      <Helmet>
        <title>Forget Password</title>
      </Helmet>
      <Typography sx={{ mb: 3 }} variant="h4" color={'primary'}>
        {t('forgetPassword.heading')}
      </Typography>
      <Box sx={{ width: '100%', margin: '0 auto' }}>
        <form onSubmit={handleSubmit(forgetform)}>
          <Grid item xs={12}>
            <CustomTextField
              label={t('forgetPassword.enterEmail')}
              type="text"
              controller={{
                name: 'email',
                control: control,
                errors: errors.email,
              }}
            />
          </Grid>
          <Grid item xs={12} sx={{ mt: 2, float: 'right' }}>
            <LoaderButton
              type="submit"
              loading={loading}
              variant="contained"
              disabled={!isValid}
              buttonText={t('forgetPassword.next')}
            />
          </Grid>
        </form>
      </Box>
    </Wrapper>
  );
};

export default ForgotPassword;
